module.exports = __webpack_public_path__ + "static/media/huoyanshan_plant.cd1c3450.webp";